<template>
    <!-- Logout Modal -->
    <div
        v-if="visible"
        class="fixed inset-0 z-50 flex items-center justify-center bg-black/60"
    >
        <div
            class="relative w-[85%] rounded-2xl border-[6px] border-purple-600 modal-background p-4 text-white shadow-xl transform animate-[fadeIn_0.3s_ease-out_forwards]">
            <img
                src="https://www.burma368.net/static/image/common/popup-icon.png"
                alt=""
                class="w-[140px] h-[74px] absolute -top-[70px] left-1/2 transform -translate-x-1/2"
            />

            <p class="text-center !text-[22px] !font-semibold leading-tight">
                {{ $t('logout.confirm_text') }}
            </p>

            <div class="flex justify-between mt-5 gap-3">
                <button
                    class="px-4 py-3 border border-purple-400 w-full text-purple-400 !rounded-full whitespace-nowrap"
                    @click="$emit('close')"
                >
                    {{ $t('logout.cancel') }}
                </button>

                <button
                    class="px-4 py-3 bg-purple-500 w-full !rounded-full whitespace-nowrap"
                    @click="$emit('confirm')"
                >
                    {{ $t('logout.confirm') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        visible: { type: Boolean, default: false },
    },
};
</script>

<style scoped>
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: scale(0.95);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
}

.modal-background {
    background: linear-gradient(180deg, #2b1c59 0%, #1b1540 100%);
    word-break: keep-all;
}
</style>
